/**
 * Sets cookie
 * @param name Cookie name
 * @param value Cookie value
 * @param secure If the cookie is a secure cookie or not
 * @param duration Duration in seconds
 */
export const setCookie = ({ name, value, secure = true, duration }) => {
  const cookieExp = new Date();
  cookieExp.setTime(cookieExp.getTime() + duration * 1000);

  // Setting secure flag on cookie will ensure it is sent to server over HTTPS connection
  const secureString = secure === true ? 'secure;' : '';

  document.cookie = `${name}=${encodeURIComponent(value)}; ${secureString} path=/; expires=${cookieExp.toGMTString()}`;
};

/**
 * Returns cookie value based on name
 * @param cookieName
 * @returns {string|null}
 */
export const getCookie = cookieName => {
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  let result = null;
  for (let i = 0; i < cookieArray.length; i++) {
    let cookieItem = cookieArray[i];
    while (cookieItem.charAt(0) == ' ') {
      cookieItem = cookieItem.substring(1);
    }
    if (cookieItem.indexOf(name) == 0) {
      result = cookieItem.substring(name.length, cookieItem.length);
    }
  }
  return result;
};
